module.exports = __webpack_public_path__ + "img/share.9685a486.png";